import { FormItem } from '../../types/types';
import { FormItemWithDefaultValues } from '../../components/Manager/DatasetForm/types';

export const createFormItem = (item: FormItem): FormItemWithDefaultValues => {
  return {
    ...item,
    editable: item.editable === undefined ? true : item.editable,
    allowEditable: item.allowEditable === undefined ? true : item.allowEditable,
    visible: item.visible === undefined ? true : item.visible,
    allowVisible: item.allowVisible === undefined ? true : item.allowVisible,
    mandatory: typeof item.mandatory === 'boolean' ? item.mandatory : false,
  };
};
